<template>
  <v-col cols="12" :md="md">
    <v-container>
      <v-row>
        <h6><b>{{item.elevator.name}}</b></h6>
      </v-row>
      <v-row>
        <p>{{item.elevator.zip}}, {{item.elevator.city}}</p>
      </v-row>
      <v-row>
        {{ customer() }}
      </v-row>
    </v-container>
  </v-col>
</template>
<script>
export default {
  name: "NameField",
  props: {
    item: Object,
    md: String
  },
  methods: {
    customer() {
      return typeof this.item.elevator.customer !== 'undefined' && this.item.elevator.customer !== null
        ? this.item.elevator.customer.name : '';
    }
  }
}
</script>